import { IBaseGridConstant } from 'v2/modules/shared/interfaces/ag-grid/ag-grid.types';

import { EFulfillmentOrdersGridField } from '../types/fulfillment-orders-grid.types';

const filterApiParamsMapping :{ [key in EFulfillmentOrdersGridField] :string } = {
  [EFulfillmentOrdersGridField.FULFILLMENT_ORDER_KEY]: 'orderKey',
  [EFulfillmentOrdersGridField.SHIPMENT_DATE]: 'shipByDate',
  [EFulfillmentOrdersGridField.QTY_SHIPPED]: 'qtyShipped',
  [EFulfillmentOrdersGridField.TRACKING_NUMBER]:
    'shipstationShipment.trackingNumbers',
  [EFulfillmentOrdersGridField.FULFILLMENT_WAREHOUSE_GROUP]: 'warehouseGroup.label',
  [EFulfillmentOrdersGridField.FULFILLMENT_DESTINATION]: 'destinationOms.label',
  [EFulfillmentOrdersGridField.DESTINATION_OMS_STORE]:
    'destinationOmsStore.storeName',
  [EFulfillmentOrdersGridField.COST]: 'cost',
  [EFulfillmentOrdersGridField.STATUS]: 'orderStatus',
  [EFulfillmentOrdersGridField.CHANNEL_SYNC]: 'channelSync',
  [EFulfillmentOrdersGridField.SOURCE_REFERENCE_IDENTIFIER]:
    'sourceReferenceIdentifier',
};

const sortingApiParamsMapping :{ [key in EFulfillmentOrdersGridField] :string } = {
  ...filterApiParamsMapping,
};

const defaultRelations :string[] = [
  'warehouseGroup:id,label',
  'shipstationShipment:id,sales_order_shipment_id,trackingNumber',
  'destinationOms:id,label',
  'destinationOmsStore:id,storeName',
  'latestActivity:id,subject_id,subject_type,created_at,updated_at,description,properties',
  'clientInvoices:id',
  'shipstationShipments',
];

export const fulfillmentOrderDetailRowRelations :string[] = [
  'salesOrderItem.rfq:id,unit_class_id',
  'salesOrderItem.rfq.baseUnitOfMeasure',
  'salesOrderItem.stock:id,warehouse_id,rfq_id',
  'salesOrderItem.stock.warehouse:id,location_name',
  'salesOrderItem.stock.rfqStockLocations:id,location_id,onhand_quantity,lot_id,rfq_stock_id',
  'salesOrderItem.stock.rfqStockLocations.location:id,location_name,parent_id',
  'salesOrderItem.stock.rfqStockLocations.lot:id,lot_number',
  'salesOrderItem.incomingPurchaseOrderRfq:id,rfq_id,purchase_order_id,ordered_qty',
  'salesOrderItem.incomingPurchaseOrderRfq.purchaseOrder:id,arrival_due_date',
  'fulfillmentOrder.warehouseGroup:id,label',
  'lot',
];

const topLevelFilters :string[] = [
  EFulfillmentOrdersGridField.QTY_SHIPPED,
  EFulfillmentOrdersGridField.COST,
];

export const FulfillmentOrdersGridConstants :IBaseGridConstant<EFulfillmentOrdersGridField> =
  {
    filterApiParamsMapping,
    sortingApiParamsMapping,
    defaultRelations,
    topLevelFilters,
  };
